import { findErrorsInModel } from '../utils/validation/findErrorsInModel';
import { validationMessages } from '../constants/validation/financialDetails';
import { isValidInput } from '../utils/validation/isValidInput';
import { isValidHouseholdIncome } from '../utils/validation/isValidHouseholdIncome';

function getSchema(model) {
  return {
    earnIncome: (value) => {
      if (model.financialCircumstances == 'Yes' && !isValidInput(value, 'Numeric')) {
        return validationMessages.earnIncome;
      }
    },
    mortgageExpense: (value) => {
      if (value === '' || value.length > 15 || !isValidInput(value, 'Numeric')) {
        return validationMessages.mortgageExpense;
      }
    },
    grossAnnualIncome: (value) => {
      if (
        value === '' ||
        value.length > 15 ||
        !isValidInput(value, 'Numeric') ||
        Number(value) === 0
      ) {
        return validationMessages.grossAnnualIncome;
      }
    },
    netMonthlyIncome: (value) => {
      // this value is still named netMonthlyIncome but the actual value it represents is the total household income

      if (
        (model && !isValidHouseholdIncome(value, model.grossAnnualIncome)) ||
        !isValidInput(value, 'Numeric') ||
        Number(value) === 0 ||
        (value !== '' && value.length > 15)
      ) {
        return validationMessages.netMonthlyIncome;
      }
    },
    financialCircumstances: (value) => value === '' && validationMessages.financialCircumstances
  };
}

export function validateModel(model) {
  return findErrorsInModel(model, getSchema(model));
}

export function validateFormField(field, value) {
  const schema = getSchema();
  return schema[field] && schema[field](value);
}
